import * as React from 'react'
import styled from 'styled-components'
import { APP_STORE_URL, PLAY_STORE_URL } from 'app.constants/appInstallUrls'

const ChannelAdBannerBox: React.FC = () => {
  return (
    <StyledWrapper>
      <img
        className="ad-banner"
        src="/static/images/channel/ad_banner.jpg"
        alt="ad-banner"
      />
      <div className="btn-list">
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="play-store-btn"
        >
          <img
            className="play-store-img"
            src="/static/images/app-banner/play-store-badge.png"
            alt="구글플레이"
          />
        </a>
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="apple-store-btn"
        >
          <img
            className="apple-store-img"
            src="/static/images/app-banner/apple-store-badge.png"
            alt="앱스토어"
          />
        </a>
      </div>
    </StyledWrapper>
  )
}

export default ChannelAdBannerBox

const StyledWrapper = styled.div`
  position: relative;
  .ad-banner {
    width: 100%;
  }
  .btn-list {
    bottom: 5px;
    left: 0;
    right: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    .play-store-btn {
      position: relative;
      width: 107px;
      img {
        width: 107px;
        height: 43px;
      }
    }
    .apple-store-btn {
      position: relative;
      width: 107px;
      img {
        width: 107px;
        height: 43px;
      }
    }
  }
`
